import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import { enable as enableDarkMode, disable as disableDarkMode } from 'darkreader';
import { Mode, toggleMode } from 'src/state/uipose/UiPose.slice';
import { AppState } from 'src/store';
import { container, labelRow } from './DarkMode.styles';


type StateProps = {
  mode: Mode;
};

type DispatchProps = {
  toggle: () => void;
};

type MenuProps = StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  return {
    mode: state.uiPose.themeMode
  }
};

const mapDispatchToProps = {
  toggle: toggleMode,
};


const applyDarkMode = (isDark: boolean) => {
  if (isDark) {
    enableDarkMode({
      brightness: 100,
      contrast: 95,
      sepia: 0,
      scrollbarColor: 'rgba(235, 235, 235, 0.5)',
    });
  } else {
    disableDarkMode();
  }
};

const DarkModeMenuItemBase = ({ mode, toggle }: MenuProps) => {
  const isDarkMode = mode === 'dark';
  return (
    <div className={container}>
      <span className={labelRow}>
        <i className={`fa ${isDarkMode ? 'fa-moon' : 'fa-sun'}`} />
        <span>{isDarkMode ? 'Dark mode' : 'Light mode'}</span>
      </span>
      <Switch
        checked={isDarkMode}
        onChange={() => toggle()}
      />
    </div>
  );
};

const DarkModeEffectBase = ({ mode }: StateProps) => {
  useEffect(() => {
    applyDarkMode(mode === 'dark');
  }, [mode]);
  return null;
};

export const DarkModeMenuItem = connect(mapStateToProps, mapDispatchToProps)(DarkModeMenuItemBase);
export const DarkModeEffect = connect(mapStateToProps)(DarkModeEffectBase);
